export default __webpack_public_path__ + "static/blog-writing-482c83c040bc2c2815ad070ad94901ed.jpg";